import React, {Component} from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

class iDayDtl extends cView{

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }
  //
  $id_stss = {
    //
//    sgcn_pageTab: 1,
    //
//    sld_cm10ss: {}, // スタッフ情報
//    sld_it60ss: {}, // 日別時間帯別情報
//    sld_it70ss: {}, // 出勤者情報
//    sld_it52ss1: {}, // 内販責任者情報
//    sld_it52ss2: {}, // 外販責任者情報
    sld_cm10ss: [], // スタッフ情報
    sld_it60ss: [], // 日別時間帯別情報
    sld_it70ss: [], // 出勤者情報
    sld_it52ss1: [], // 内販責任者情報
    sld_it52ss2: [], // 外販責任者情報
    //
    s_it50b11k: '', //cm20_key
    s_it50b21k: '', //it60_key
    s_it50t110: '0', //営業日区分
    s_it50s110: '0', // 閉店状況、0:未設定、10：レジ開設中、20：レジ締め済
    s_it50d110: bf.myDT_get_date('today'), // 開店日
    s_it50d210: '', // 開店日時
    s_it50d220: '', // 閉店日時
    s_it50i110: '0', //大入目標額
    s_it50i210: '0', //売上
    s_it50i220: '0', //内カード売上
    s_it50i310: '0', //雑費レシート
    s_it50i320: '0', //日払い領収書
    s_it50i410: '0', //中身
    s_it50i510: '0', //前日レジ金
    s_it50i520: '0', //本日レジ金
    s_it50i810: '0', //客数
    s_it50i820: '0', //客単価
    s_it50i830: '0',
    s_it50i840: '0',
    s_it50i910: '0', //外販客数
    s_it50i920: '0', //新規客数
    s_it50i930: '0', //反響率
    s_it50ia10: '0', //配布枚数計
    s_it50ib10: '0', //経費
    s_it50ib20: '0', //男子給
    s_it50ib30: '0', //女子給
    s_it50ib40: '0', //ドリンク
    s_it50ib50: '0', //大入手当
    s_it50ib60: '0', //雑費
    s_it50ib70: '0', //酒代
    s_it50ib80: '0', //ランコス
    s_it50ic10: '0', //利益
  };

  $ilp_bfrLoads = () => [
/*
    cp.$cp_load_cm10({ // スタッフ情報
      mode: 'items',
      b_wotDlt: true,
      state: 'sld_cm10ss',
      cnd: bf.q('[cm10b21k]="{}" AND IFNULL([cm10cz10],"10")<>"0"'.f(
        global.c?.state.sgcd_pageCmns?.cm20_key
      )),
    }),
*/
/*
    new Promise( _o_end2 => {
      cp.$cp_load_cm10({ // スタッフ情報
        mode: 'items',
        b_wotDlt: true,
        state: 'sld_cm10ss',
        cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
      })
      .then(() => {
        global.c?.setState({
          sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
            _next
            .map( (_d_cm10s, _idx) => {
              if (
                bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                bf.n(_d_cm10s.val.cm10cz10) != 10
              ) {
                _d_cm10s.b_hide = true;
              }
              else {
                _d_cm10s.b_hide = false;
              }
            })
          }),
        }, () => {
          _o_end2();
        });
      })
    }),
*/
  ];

  $ilp_loads = () => [
/*
    ip.$ip_load_it50({
      mode: 'set',
      b_clr: false,
      it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
    }),
*/
/*
    new Promise( _o_end1 => {
      ip.$ip_load_it50({
        mode: 'set',
        b_clr: false,
        it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
      })
      .then(() => {
        cf.myRN_setCmns({
          cm20_key: global.c?.state.s_it50b11k,
        })
        .then(() => {
          Promise.all([
            new Promise( _o_end2 => {
              cp.$cp_load_cm10({ // スタッフ情報
                mode: 'items',
                b_wotDlt: true,
                state: 'sld_cm10ss',
                cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
              })
              .then(() => {
                global.c?.setState({
                  sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
                    _next
                    .map( (_d_cm10s, _idx) => {
                      if (
                        bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                        bf.n(_d_cm10s.val.cm10cz10) != 10
                      ) {
                        _d_cm10s.b_hide = true;
                      }
                      else {
                        _d_cm10s.b_hide = false;
                      }
                    })
                  }),
                }, () => {
                  _o_end2();
                });
              })
            }),
          ])
          .then(() => {
            _o_end1();
          });
        });
      })
    }),
*/
    new Promise( _o_end1 => {
bf.l('173: here')
      ip.$ip_load_it50({
        mode: 'set',
        b_clr: false,
        it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
      })
      .then(() => {
        cf.myRN_setCmns({
          cm20_key: global.c?.state.s_it50b11k,
        })
        .then(() => {
          cp.$cp_load_cm10({ // ユーザ情報の設定
            mode: 'set',
            cnd: bf.q(`
              [cm10b21k]="{}" AND 
              [cm10i110]=(
                SELECT
                  [cm10i110]
                FROM
                  [t_cm10]
                WHERE
                  [_KEY]={}
              ) AND
              IFNULL([cm10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pageCmns.cm20_key,
              global.c?.state.sgcd_pageCmns.user_key, // op_loadAll との違い
            )),
          })
          .then( _d_cm10s => {
            if (bf.f(_d_cm10s) == false) { // ユーザ情報を確認できなかった場合
              alert('店舗において、ユーザを確認できませんでした。');
              let _d_pageInfs =  iv.get_iniPageInfs(global.c?.state.sgcd_pageModes.user_key, global.c?.state.sgcd_pageModes.userc410);
              cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                _next[_d_pageInfs.sgc_pageName] = 'show';
              }))
              .then(() => {
                cf.myRN_move_fwd(_d_pageInfs)
                .then(() => {
                  _o_end1(-1);
                });
              });
            }
            else { // ユーザ情報を確認できた場合
              cf.myRN_setCmns({ // 入店情報の店舗のユーザと同期を取る
                cm10_key: _d_cm10s._KEY,
              })
              .then(() => {
                Promise.all([
                  new Promise( _o_end2 => {
                    cp.$cp_load_cm10({ // スタッフ情報
                      mode: 'items',
                      b_wotDlt: true,
                      state: 'sld_cm10ss',
                      cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
                    })
                    .then(() => {
                      global.c?.setState({
                        sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
                          _next
                          .map( (_d_cm10s, _idx) => {
                            if (
                              bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                              bf.n(_d_cm10s.val.cm10cz10) != 10
                            ) {
                              _d_cm10s.b_hide = true;
                            }
                            else {
                              _d_cm10s.b_hide = false;
                            }
                          })
                        }),
                      }, () => {
                        _o_end2();
                      });
                    })
                  }),

                  new Promise( _o_end2 => { // 日別時間帯別情報
                    if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show') { // 既存
                      ip.$ip_load_it51({
                        mode: 'clds',
                        it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
                        ld_sortss: [
                          {
                            fld: 'it51d310', 
                            dtn: 'asc',
                          }
                        ],
                      })
                      .then(() => {
                        _o_end2();
                      })
                    }
                    else {
                      _o_end2();
                    }
                  }),

                  ip.$ip_load_it70({ // 出勤情報
                    mode: 'clds',
                    state: 'sld_it70ss',
                    it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
                    ld_sortss: [{fld:'cm10c330', dtn:'asc'}],
                    do_rfrs: {
                      cm10: _d_is => bf.q('[_KEY]={}'.f(
                        _d_is.it70b11k
                      )),
                    },
                  }),

                  ip.$ip_hlr_it52({ // 外販責任者
                    mode: 'clds',      
                    b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
                    state: 'sld_it52ss1',
                    cnd: bf.q('[it52b21k]="{}" AND [it52t110]="10" AND IFNULL([it52cz10],"10")<>"0"'.f(
                      global.c?.state.sgcd_pageCmns?.it50_key,
                    )),
                  }),

                  ip.$ip_hlr_it52({ // 内販責任者
                    mode: 'clds',      
                    b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
                    state: 'sld_it52ss2',
                    cnd: bf.q('[it52b21k]="{}" AND [it52t110]="20" AND IFNULL([it52cz10],"10")<>"0"'.f(
                      global.c?.state.sgcd_pageCmns?.it50_key,
                    )),
                  }),

                ])
                .then(() => {
                  _o_end1(1);
                });
              });
            };
          });
        });
      })
    }),
  ];
  //
  $ilp_bfrIuds = () => [
  ];

  $ilp_upds = () => [
//    ip.$ip_upd_it50(),
    new Promise( _o_end1 => {
      ip.$ip_upd_it50()
      .then(() => {
        cf.myCB_callQrys({
          l_tgts: ['it50t110', 'it50i110', 'it50ib10', 'it50i520'],
          dd_qryss: ip.dd_qryss,
          d_vals: {
            it60_key: global.c?.state.s_it50b21k,
            it50_key: global.c?.state.sgcd_pageCmns?.it50_key,
          },
        })
        .then(() => {
          _o_end1();
        });
      });
    }),
    ip.$ip_upd_it51(),
    ip.$ip_ups_it70(),
    new Promise( _o_end1 => {
      ip.$ip_hlr_it52({
        mode: 'upsClds',
        state: 'sld_it52ss1',
        it52t110: '10', // 外販責任者
      })
      .then(() => {
        let _qry = bf.q('UPDATE [t_it50] SET [{}]=array_to_string((SELECT array_agg([cm10c330]) FROM [t_cm10] WHERE [_KEY] IN (SELECT [it52b31k]::NUMERIC::INTEGER FROM [t_it52] WHERE [it52b21k]=[t_it50].[_KEY]::TEXT AND [it52t110]="{}" AND IFNULL([it52cz10],"10")<>"0")), ",") WHERE [_KEY]={}'.f(
          'it50id10',
          '10',
          global.c?.state.sgcd_pageCmns?.it50_key,
        ));
        cf.myCB_call_iud({
          ctr: 'qry', 
          elm: 'it52',
          qry: _qry, 
        })
        .then( () => {
          _o_end1();
        });
      });
    }),
    new Promise( _o_end1 => {
      ip.$ip_hlr_it52({
        mode: 'upsClds',
        state: 'sld_it52ss2',
        it52t110: '20', // 内販責任者
      })
      .then(() => {
        let _qry = bf.q('UPDATE [t_it50] SET [{}]=array_to_string((SELECT array_agg([cm10c330]) FROM [t_cm10] WHERE [_KEY] IN (SELECT [it52b31k]::NUMERIC::INTEGER FROM [t_it52] WHERE [it52b21k]=[t_it50].[_KEY]::TEXT AND [it52t110]="{}" AND IFNULL([it52cz10],"10")<>"0")), ",") WHERE [_KEY]={}'.f(
          'it50id20',
          '20',
          global.c?.state.sgcd_pageCmns?.it50_key,
        ));
        cf.myCB_call_iud({
          ctr: 'qry', 
          elm: 'it52',
          qry: _qry, 
        })
        .then( () => {
          _o_end1();
        });
      });
    }),
  ];

  //
  _onPrsOpenRtr = () => { // レジ開設
    // 同一店舗において、翌日以降にレジ開設中・締切済の日別データが存在する場合、前日以前に開設中のレジがある場合は、レジ開設を不可とする
//      ([it50b11k]="{}" AND [it50d110]>"{}" AND [it50s110] IN ("10", "20")) OR 
    let _cnd = bf.q(`
      ([it50b11k]="{}" AND [it50d110]>"{}" AND [it50s110] IN ("10")) OR 
      ([it50b11k]="{}" AND [it50d110]<"{}" AND [it50s110] IN ("10"))
    `.f(
      global.c?.state.s_it50b11k,
      global.c?.state.s_it50d110,
      global.c?.state.s_it50b11k,
      global.c?.state.s_it50d110,
    ));
//bf.l(_cnd);
    cf.myCB_call_slc({ // 重複するレジの確認
      ctr: 'nlm', 
      elm: 'it50', 
      n_dms: 2, 
      cnd: _cnd
    })
    .then( _d_it50s => {
      if (!bf.f(_d_it50s)) { // 重複データが存在しない場合
        let _cnd2 = bf.q(`
          [_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it50_key,
        ));
        cf.myCB_call_slc({ // 重複するレジの確認
          ctr: 'nlm', 
          elm: 'it50', 
          n_dms: 2, 
          cnd: _cnd2
        })
        .then( _d_it50s => {
          ip.$ip_ups_it51s({ // 日別時間帯別情報を追加
            d_it50s: _d_it50s,
          })
          .then(() => {
            global.c?.setState({
              s_it50s110: '10',
              s_it50d210: bf.myDT_get_now(),
              s_it50d220: bf.maxDtm,
              s_it50cy50: bf.myDT_get_now(),
    //          s_it50cy60: global.c?.state.sgcd_pageCmns?.user_key,
              s_it50cy60: global.c?.state.sgcd_pageCmns?.cm10_key,
            }, () => {
    //bf.l('412: here')
              global.c?.upd();
            })
          });
        });
      }
      else {
        alert('開設中または締切済の日別情報が存在するためレジを開設・再開できません。');
      }
    });
  };
  //
  _onPrsClsRtr = () => { // レジ締め
    let _cnd = bf.q(`
      [it10b31k]="{}" AND [it10s110]="10"
    `.f(
      global.c?.state.sgcd_pageCmns?.it50_key,
    ));
//bf.l('427: {}'.f(_cnd))
    cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: 'it10', 
      n_dms: 2, 
      cnd: _cnd
    })
    .then( _d_it10s => {
//bf.l('435: {}'.f(_d_it10s))
      if (!bf.f(_d_it10s)) {
        global.c?.setState({
          s_it50s110: '20',
          s_it50d220: bf.myDT_get_now(),
          s_it50cy70: bf.myDT_get_now(),
//          s_it50cy80: global.c?.state.sgcd_pageCmns?.user_key,
          s_it50cy80: global.c?.state.sgcd_pageCmns?.cm10_key,
        }, () => {
//bf.l('444: {}'.f(bf.myDT_get_now(), global.c?.state.sgcd_pageCmns?.cm10_key))
          global.c?.upd();
        })
      }
      else {
        alert('接客中の顧客情報が存在するためレジを締切できません。');
      }
    });
  };
  //
  _onPrsReOpenRtr = () => { // レジ再開
    // 翌日以降にレジ開設中・締切済の日別データが存在する場合、前日以前に開設中のレジがある場合は、レジ再開を不可とする
/*
    let _cnd = bf.q(`
      [it50b11k]="{}" AND [it50d110]>"{}" AND [it50s110] IN ("10", "20")
    `.f(
      global.c?.state.s_it50b11k,
      global.c?.state.s_it50d110,
    ));
*/
    let _cnd = bf.q(`
      ([it50b11k]="{}" AND [it50d110]>"{}" AND [it50s110] IN ("10")) OR 
      ([it50b11k]="{}" AND [it50d110]<"{}" AND [it50s110] IN ("10"))
    `.f(
      global.c?.state.s_it50b11k,
      global.c?.state.s_it50d110,
      global.c?.state.s_it50b11k,
      global.c?.state.s_it50d110,
    ));
//bf.l(_cnd);
    cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: 'it50', 
      n_dms: 2, 
      cnd: _cnd
    })
    .then( _d_it50s => {
      if (!bf.f(_d_it50s)) {
        global.c?.setState({
          s_it50s110: '10',
          s_it50d220: bf.maxDtm,
        }, () => {
          global.c?.upd();
        })
      }
      else {
//        alert('開設中または締切済の日別情報が存在するためレジを再開できません。');
        alert('開設中または締切済の日別情報が存在するためレジを開設・再開できません。');
      }
    });

  };

/*  
  _onBlurIt50b = () => {
    let _it50ib10 = 
      bf.n(global.c?.state.s_it50ib20 || '0')
      + bf.n(global.c?.state.s_it50ib30 || '0')
      + bf.n(global.c?.state.s_it50ib40 || '0')
      + bf.n(global.c?.state.s_it50ib50 || '0')
      + bf.n(global.c?.state.s_it50ib60 || '0')
      + bf.n(global.c?.state.s_it50ib70 || '0')
      + bf.n(global.c?.state.s_it50ib80 || '0');
    global.c?.setState({
      s_it50ib10: _it50ib10,
      s_it50ic10: bf.n(global.c?.state.s_it50i210) - _it50ib10,
    }, () => {
    });
  };
*/

//  $ild_onChgss = ip.ild_onChgss; // ★

  $pdo_onChgs = () => ({
    s_it50i210: () => {
      ip._updIt50i520();
      ip._updIt50ic10();
    },
//    s_it50i310: () => ip._updIt50i520,
    s_it50i310: () => {
      ip._updIt50i520();
      ip._updIt50ib10();
    },
    s_it50i320: () => ip._updIt50i520,
    s_it50i410: () => ip._updIt50i520,
    s_it50i510: () => ip._updIt50i520,
    s_it50ib10: () => ip._updIt50ic10,
    s_it50ib20: () => ip._updIt50ib10,
    s_it50ib30: () => ip._updIt50ib10,
    s_it50ib40: () => ip._updIt50ib10,
    s_it50ib50: () => ip._updIt50ib10,
    s_it50ib60: () => ip._updIt50ib10,
    s_it50ib70: () => ip._updIt50ib10,
    s_it50ib80: () => ip._updIt50ib10,
  });

  render(){
    return (
      <this.$onChg>
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_rhtVsb={(global.c?.state.s_it50s110 == '10') ? true : false}
        rhtPfx={null}
        onRhtPrs={null}
        d_hdrs={{
          pfx: iv._get_hdrPfx('日別情報（{}）'.f(global.c?.state.s_it50d110)),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50d110',
              pfx:'営業日',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (global.c?.state.s_it50s110 == '0' || bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50t110',
              pfx:'営業日区分',
              b_mln:false,
              ld_itemss:[
                {key:'0', pfx: '休業'},
                {key:'10', pfx: '平日'},
                {key:'20', pfx: '金・土・祝前日'},
                {key:'30', pfx: '日・祝日'},
              ],
            },
/*
            {
              type:'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50id20',
              pfx:'内販管理者',
              b_mln:false,
              ld_itemss: global.c?.state.sld_cm10ss,
            },
            {
              type:'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50id10',
              pfx:'外販管理者',
              b_mln:false,
              ld_itemss: global.c?.state.sld_cm10ss,
            },
*/
            {
              type: 'Clds',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state: 'sld_it52ss2',
              pfx: '内販責任者',
              b_oneTtl: true,
              dd_defss: {
                it52b31k: {
                  type:'Pck',
                  b_vsb:true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  b_dlt: true,
                  pfx:'',
                  ld_itemss: global.c?.state.sld_cm10ss,
                  onCls:null,
                  onChg:null,
                },
              },
            },
            {
              type: 'Clds',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state: 'sld_it52ss1',
              pfx: '外販責任者',
              b_oneTtl: true,
              dd_defss: {
                it52b31k: {
                  type:'Pck',
                  b_vsb:true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  b_dlt: true,
                  pfx:'',
                  ld_itemss: global.c?.state.sld_cm10ss,
                  onCls:null,
                  onChg:null,
                },
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50i110',
              pfx:'大入設定額',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (global.c?.state.s_it50s110 == '0' || bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50i710',
              pfx:'連絡事項',
              b_mln:true,
            },
            {
              type: 'Btns',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              ld_defss: [
                {
                  pfx: 'レジ開設',
                  b_vsb: (global.c?.state.s_it50s110 == '0') ? true : false,
                  onPrs: global.c?._onPrsOpenRtr,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: 'レジ締切',
                  b_vsb: (global.c?.state.s_it50s110 == '10') ? true : false,
                  onPrs: global.c?._onPrsClsRtr,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: 'レジ再開',
                  b_vsb: (global.c?.state.s_it50s110 == '20') ? true : false,
                  onPrs: global.c?._onPrsReOpenRtr,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
              ],
              stlCta: {
                marginTop: ic.gn_mgnLrg,
                marginBottom: ic.gn_mgnLrg,
              },
            },
            {
              type:'Pck',
//              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_vsb: false,
              b_edt:false,
              state:'s_it50s110',
              pfx:'レジ状況',
              b_mln:false,
              ld_itemss:[
                {key:'0', pfx: '開設前'}, // 未接客
                {key:'10', pfx: '開設中'}, // 接客中
                {key:'20', pfx: '締切済'}, // 接客済
              ],
            },
            {
              type:'Inp',
//              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_vsb: false,
              b_edt:false,
              state:'s_it50d210',
              pfx:'レジ開設日時',
              b_mln:false,
              o_stlVal: _d => {
                return _d.val.substr(0,16)
              },
            },
            {
              type:'Inp',
//              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_vsb: false,
              b_edt:false,
              state:'s_it50d220',
              pfx:'レジ締切日時',
              b_mln:false,
              o_stlVal: _d => {
                return _d.val.substr(0,16)
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i210',
              pfx:'売上',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i220',
              pfx:'内カード売上',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50i310',
              pfx:'雑費レシート',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50i320',
              pfx:'日払い領収書',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib70',
              pfx:'酒代',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50i410',
              pfx:'中身',
              b_mln:false,
//              onBlur: global.c?._forChgIt50i520,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i510',
              pfx:'レジ金（前日）',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i520',
              pfx:'レジ金（当日）',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i870',
              pfx:'総組数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i810',
              pfx:'総客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i880',
              pfx:'組単価',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i820',
              pfx:'客単価',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i840',
              pfx:'延長率',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ia10',
              pfx:'配布枚数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i910',
              pfx:'外販客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i920',
              pfx:'新規客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i930',
              pfx:'反響率（%）',
              b_mln:false,
            },
/*
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it50i830',
              pfx:'延長客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
*/
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib20',
              pfx:'男子給',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib30',
              pfx:'女子給',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib40',
              pfx:'ドリンク',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib50',
              pfx:'大入手当',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
/*
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib60',
              pfx:'雑費',
              b_mln:false,
              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
*/
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: false,
              state:'s_it50i310',
              pfx:'雑費レシート',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: false,
              state:'s_it50ib70',
              pfx:'酒代',
              b_mln:false,
//              onBlur: global.c?._onBlurIt50b,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it50ib80',
              pfx:'ランコス',
//              onBlur: global.c?._onBlurIt50b,
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
              b_edt:false,
              state:'s_it50ib10',
              pfx:'経費',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false, // 事務担当者
//              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              b_edt: false,
              b_newLine: false,
              state:'s_it50ic10',
              pfx:'利益',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type: 'Clds',
              b_vsb: (global.c?.state.sgcn_pageTab == 2) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
//              state: 'sld_it70ss',
              state: 'sld_it70ss',
              pfx: '出勤情報({})',
              dd_defss: {
                it70b11k:{
                  type: 'Pck',
                  b_vsb: true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  b_dlt: true,
                  pfx: '出勤者',
                  ld_itemss: global.c?.state.sld_cm10ss,
                },
                it70d310:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  pfx: '出勤時刻（hhmm、半角数字） 例)25時半は「0130」と入力',
                  b_mln: false,
                  kbdType: 'numeric',
                },
                it70d320:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  pfx: '退勤時刻（hhmm、半角数字） 例)25時半は「0130」と入力',
                  b_mln: false,
                  kbdType: 'numeric',
                },
                it70i110:{
                  type: 'Pck',
                  b_vsb: true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  pfx: '遅刻・欠勤・無断欠勤',
                  ini: '0',
                  ld_itemss: [
                    {key:'0', pfx: 'なし'},
                    {key:'100', pfx: '遅刻'},
                    {key:'910', pfx: '欠勤'},
                    {key:'920', pfx: '無断欠勤'},
                  ],
                },
                it70i120:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  pfx: '備考',
                  b_mln: false,
                },
              },
            },
            {
              type: 'Clds',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: true,
              b_newLine: false,
              state: 'sld_it51ss',
              pfx: '',
              b_oneTtl: true,
              dd_defss: {
                it51i110:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
//                  pfx: '入店客数（{it51d210}時）',
                  o_pfx: _d_is => '入店客数（{}時）'.f(_d_is.it51d210),
                  b_mln: false,
                },
              },
            },
          ],
        }}
        d_btms={{
          n_h: ic.gn_fontSizeNrm + ic.gn_bdrWNrw * 2 + ic.gn_mgnNrm * 4,
          ld_defss: [
            {
              type: 'Btns',
              b_vsb: true,
              ld_defss: [
                {
                  pfx: '基本情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 1) ? false : true,
                  onPrs: () => global.c?.$onPrsTab({n_tab: 1}),
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: '出勤情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 2) ? false : true,
                  onPrs: () => global.c?.$onPrsTab({n_tab: 2}),
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: '時間帯別情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 3) ? false : true,
                  onPrs: () => global.c?.$onPrsTab({n_tab: 3}),
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
              ],
              stlCta: {
                marginTop: ic.gn_mgnLrg,
                marginBottom: ic.gn_mgnLrg,
              },
            },
          ],
        }}
      />
      </this.$onChg>
    );
  }        
}

export default iDayDtl;
